import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { selectUnreadCount } from "@/store/user/selectors";
import KycIframeModal from "@/components/Modal/KycIframeModal";

const NotificationDropdown = ({ t, unreadCount }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div style={{ position: "relative", display: "inline-flex" }}>
        <button
          onClick={() => setShow(true)}
          title={t("Notifications")}
          className="btn header-item waves-effect"
          style={{ padding: "10px" }}
        >
          <i className="uil uil-bell" style={{ fontSize: 18 }} />
        </button>
        {unreadCount > 0 && (
          <span
            className="badge bg-danger rounded-pill"
            style={{
              position: "absolute",
              top: 15,
              right: 2,
              fontSize: 10,
              fontWeight: 700,
              minWidth: 16,
              padding: "1px 4px",
              lineHeight: 1.4,
              pointerEvents: "none",
            }}
          >
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </div>

      <KycIframeModal mode="notifications" show={show} onHide={() => setShow(false)} />
    </>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  unreadCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  unreadCount: selectUnreadCount(state.UserReducer),
});

export default withTranslation()(connect(mapStateToProps)(NotificationDropdown));
